import {
	EmailTemplateAssetType,
	EmailTemplateConfiguration,
} from "../model/bps-admin/email-template-configuration";
import { apiSlice } from "../stores/base/api-slice";

// BPS admin only — every route here sits behind the gateway's BpsAdminPolicy. Each call names
// the utility, because the admin's own JWT tenant is not the one being configured.
const serviceBaseUrl = "/notification/email-template-configuration";

const emailTemplateConfigurationEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getEmailTemplateConfiguration: builder.query<EmailTemplateConfiguration, string>({
			query: utilityId => ({ url: serviceBaseUrl, params: { utilityId } }),
			providesTags: ["EmailTemplateConfiguration"],
		}),
		// Live the moment it lands: the tenant's blob of that type is overwritten in place,
		// so this is only called from Save, never when a file is picked.
		uploadEmailTemplateAsset: builder.mutation<
			{ url: string },
			{ utilityId: string; assetType: EmailTemplateAssetType; file: File }
		>({
			query: ({ utilityId, assetType, file }) => {
				const body = new FormData();
				body.append("UtilityId", utilityId);
				body.append("AssetType", assetType);
				body.append("File", file);

				return { url: `${serviceBaseUrl}/assets`, method: "POST", body };
			},
		}),
		saveEmailTemplateConfiguration: builder.mutation<
			void,
			{ utilityId: string; configuration: EmailTemplateConfiguration }
		>({
			query: ({ utilityId, configuration }) => ({
				url: serviceBaseUrl,
				method: "PUT",
				body: { utilityId, ...configuration },
			}),
			invalidatesTags: ["EmailTemplateConfiguration"],
		}),
	}),
});

export const {
	useGetEmailTemplateConfigurationQuery,
	useUploadEmailTemplateAssetMutation,
	useSaveEmailTemplateConfigurationMutation,
} = emailTemplateConfigurationEndpoints;
